import React from 'react';
import { StretchBannerProps } from '../types';
import { Stretch } from './stretch';
import { useStretchBannerManualHide } from '../hooks';

export function StretchBanner(props: Readonly<StretchBannerProps> = {} as StretchBannerProps) {
  const {
    banners,
    width,
    height,
    closeButton,
    gaPosition,
    gaName,
    viewingTime,
    autohide,
    autohideViews,
    onImpressionContentClick,
    onImpressionContentView,
  } = props;

  const { isHiddenManual, hideBanner } = useStretchBannerManualHide();

  if (!banners.web?.content) return null;
  if (isHiddenManual) return null;

  return (
    <Stretch
      onHiddenBanner={hideBanner}
      width={width}
      height={height}
      showCloseButton={closeButton}
      autohide={autohide}
      autohideViews={autohideViews}
      gaPosition={gaPosition}
      gaName={gaName}
      banners={banners}
      viewingTime={viewingTime}
      onImpressionContentClick={onImpressionContentClick}
      onImpressionContentView={onImpressionContentView}
    />
  );
}
